import { render, staticRenderFns } from "./FormChild.vue?vue&type=template&id=2c4486cc"
import script from "./FormChild.vue?vue&type=script&lang=js"
export * from "./FormChild.vue?vue&type=script&lang=js"
import style0 from "./FormChild.vue?vue&type=style&index=0&id=2c4486cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports